import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";

type UseUserProfileProps = {
  userId?: string;
  email?: string;
};

/**
 * Custom hook to fetch user profile data.
 * @param {object} props - The properties containing userId or email.
 * @returns {{userProfile: object, loading: boolean}} - The user profile data and loading state.
 */
export function useUserProfile(props: UseUserProfileProps) {
  const { userId, email } = props || {};

  const { data, loading, error } = useQuery<any>(queries.getUserProfile, {
    variables: {
      userId,
      email,
    },
    skip: !userId && !email,
  });

  return {
    userProfile: data?.getUser || data?.comGetUser || null,
    loading,
    error,
  };
}
